@if (dataSource.data) {
  <mat-table #table [dataSource]="dataSource" [ngClass]="{dense: isDense}">
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef> {{'common.name' | translate}} </mat-header-cell>
      <mat-cell *matCellDef="let element">
        @if (element.def?.style) {
          <span [style]="element.def.style">{{element.name}}</span>
        }
        @if (!element.def?.style) {
          <span>{{element.name}}</span>
        }
        @if (element.def?.description) {
          <mat-icon [matTooltip]="element.def.description" class="descriptionTooltipIcon">help_outline</mat-icon>
        }
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="value">
      <mat-header-cell *matHeaderCellDef> {{'common.value' | translate}} </mat-header-cell>
      <mat-cell *matCellDef="let element">
        @if (valueTemplates[element.def.prop]) {
          <ng-container *ngTemplateOutlet="valueTemplates[element.def.prop]; context: { $implicit: element }"></ng-container>
        } @else {
          @if (element.def?.style) {
            <span [style]="element.def.style">{{element.value}}</span>
          }
          @if (!element.def?.style) {
            <span>{{element.value}}</span>
          }
        }
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="actions">
      <mat-header-cell fxFlex="10%" *matHeaderCellDef> Actions </mat-header-cell>
      <mat-cell fxFlex="10%" *matCellDef="let element">
        @if (element.def?.action) {
          <button mat-icon-button [matTooltip]="element.def.action.tooltip" (click)="actionClicked.emit(element)">
            <mat-icon>{{element.def.action.icon}}</mat-icon>
          </button>
        }
        @if (element.def?.action2) {
          <button mat-icon-button [matTooltip]="element.def.action2.tooltip" (click)="action2Clicked.emit(element)">
            <mat-icon>{{element.def.action2.icon}}</mat-icon>
          </button>
        }
        @if (element.def?.action3) {
          <button mat-icon-button [matTooltip]="element.def.action3.tooltip" (click)="action3Clicked.emit(element)">
            <mat-icon>{{element.def.action3.icon}}</mat-icon>
          </button>
        }
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="nameValueColumns" style="display: none;"></mat-header-row>
    <mat-row *matRowDef="let row; columns: nameValueColumns;"></mat-row>
  </mat-table>
}
